import { useEffect, useState } from "react"
import { Section } from "../../../shared/components/Section/Section"
import ArticlesList from "./articles-list"
import { CustomButton } from "../../../shared/components/CustomButton/CustomButton"
import { useTranslation } from "react-i18next"

export const ArticlesSection = () => {
    const { t }: any = useTranslation()
    const [isMobile, setIsMobile] = useState(
        window.matchMedia('(max-width: 768px)').matches
    )
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)')
        const handleChange = (e: any) => setIsMobile(e.matches)

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])
    return (<>
        <Section
            headerConfig={{
                title: t('notes.title'),
                description: '',
                inLine: !isMobile,
                maxWidth: '100%',
            }}
        >
            <div className="notas">
                <ArticlesList />
                <div className="knowStories-container">
                    <CustomButton
                        to="https://www.elclip.org/litio-en-conflicto/"
                        icon="go"
                    >
                        {t('notes.knowStories1')}
                    </CustomButton>

                    <CustomButton
                        to="https://www.elclip.org/las-grietas-del-litio/ "
                        icon="go"
                    >
                        {t('notes.knowStories2')}
                    </CustomButton>
                </div>
            </div>
        </Section>
    </>)
}

export default ArticlesSection